//import $ from "jquery";

window.showAlert = function (alertHeading = 'Alert', alertBody = 'Something has happened', alertButton = '', alertDuration = 2) {

    //console.log('showAlert');

    let $customAlert = $('#custom-alert');

    //console.log($customAlert);

    if ($customAlert.length === 0) { return; }

    if (alertHeading !== '') {
        $customAlert.find('#custom-alert-heading').removeClass('hide').html(alertHeading);
    } else {
        $customAlert.find('#custom-alert-heading').addClass('hide').html('');
    }

    if (alertBody !== '') {
        $customAlert.find('#custom-alert-body').removeClass('hide').html(alertBody);
    } else {
        $customAlert.find('#custom-alert-body').addClass('hide').html('');
    }

    if (alertButton !== '') {
        $customAlert.find('#custom-alert-button button').html(alertButton);
        $customAlert.find('#custom-alert-button').removeClass('hide');
        initCustomAlertButton();
    } else {
        $customAlert.find('#custom-alert-button').addClass('hide');
        $customAlert.find('#custom-alert-button button').html('');
    }

    $customAlert.removeClass('hide');

    if (alertDuration) {

        alertDuration = parseFloat(alertDuration);
        if ((!isNaN(alertDuration)) && (alertDuration > 0)) {
            setTimeout(function() {
                $('#custom-alert').addClass('hide');
            }, (alertDuration * 1000));
        }

    }

}

function initCustomAlertButton() {

    $('#custom-alert-button button').unbind('click');
    $('#custom-alert-button button').on('click', function() {
        // Close the alert
        $('#custom-alert').addClass('hide');
    });

}
